var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.actionComponent,_vm._g(_vm._b({tag:"component",staticClass:"title-section-action",attrs:{"label":_vm.label,"name":_vm.$attrs.name || _vm.label}},'component',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }